import { Environment } from './environment';

const composedChartColors = {
    [Environment.Staging]: ['#00cfff', '#007eff'],
    [Environment.Testing]: ['#00d9d2', '#0087a3'],
    [Environment.Production]: ['#d392ff', '#4e3efc'],
};

export default composedChartColors;